import React, { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useGroup } from "../contexts/GroupContext.tsx";

const CommunityEntryPoint: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();
  const { setGroupId } = useGroup();

  useEffect(() => {
    if (groupId) {
      setGroupId(groupId.toLowerCase());
    }
  }, [groupId]);

  // Redirect alla home (RegionSelector)
  return <Navigate to="/" replace />;
};

export default CommunityEntryPoint;
